import { useEditor, useNode } from "@craftjs/core";
import { cn } from "@/lib/utils";
import { sanitizeEmbedHtml } from "@/lib/utils/sanitize-embed";
import { applyStyleProps, defaultStyleProps, type ResponsiveStyleProps } from "@/lib/craft/style-props";
import { HtmlEmbedBlockSettings } from "@/components/craft/settings/HtmlEmbedBlockSettings";

type HtmlEmbedBlockProps = {
  html: string;
  style?: ResponsiveStyleProps;
};

export function HtmlEmbedBlock({ html = "", style = defaultStyleProps() }: HtmlEmbedBlockProps) {
  const { enabled } = useEditor((s) => ({ enabled: s.options.enabled }));
  const {
    connectors: { connect, drag },
    selected,
    id,
  } = useNode((node) => ({ selected: node.events.selected, id: node.id }));
  const { style: inlineStyle, className: styleClass } = applyStyleProps(style, "desktop", id);

  const safe = sanitizeEmbedHtml(html);

  return (
    <div
      ref={(ref) => { if (ref) connect(drag(ref)); }}
      className={cn("my-6", `craft-node-${id}`, styleClass, selected && "outline outline-2 outline-dashed outline-primary/30")}
      style={inlineStyle}
    >
      {enabled && !html.trim() ? (
        <p className="text-sm text-muted-foreground">Add HTML in the settings panel.</p>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: safe }} />
      )}
    </div>
  );
}

HtmlEmbedBlock.craft = {
  displayName: "HTML embed",
  props: { html: "", style: defaultStyleProps() },
  rules: { canDrag: () => true },
  related: { settings: HtmlEmbedBlockSettings },
};
